module.exports = __webpack_public_path__ + "media/C_round_lose.c2b4f37e.mp3";